import { FunctionComponent } from 'react';
import { ImportCustomFilesFromFTPPage } from '.';

export const ImportCustomFilesFromFTP: FunctionComponent = () => {
	return <ImportCustomFilesFromFTPPage />;
};
